// Configuration for the LaundryBnB frontend
export const config = {
  // Backend Configuration
  BACKEND_URL: '/api',
  
  // Environment
  ENV: process.env.REACT_APP_ENV || 'development',
  
  // App settings
  APP_NAME: 'LaundryBnB',
  COMPANY_NAME: 'Washmii',
}; 